var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "modoul" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.setting.title,
            visible: _vm.setting.visible,
            width: "600",
            "before-close": _vm.handleClose,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              return _vm.$set(_vm.setting, "visible", $event)
            },
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "formModal",
                  attrs: {
                    model: _vm.formModal,
                    rules: _vm.rules,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "标题", prop: "newsFlashTitle" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入标题名称" },
                        model: {
                          value: _vm.formModal.newsFlashTitle,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "newsFlashTitle", $$v)
                          },
                          expression: "formModal.newsFlashTitle",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "来源", prop: "flashSourceName" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入来源" },
                        model: {
                          value: _vm.formModal.flashSourceName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "flashSourceName", $$v)
                          },
                          expression: "formModal.flashSourceName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "内容", prop: "newsFlashContent" } },
                    [
                      _c("ueditor-from", {
                        attrs: { content: _vm.formModal.newsFlashContent },
                        model: {
                          value: _vm.formModal.newsFlashContent,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "newsFlashContent", $$v)
                          },
                          expression: "formModal.newsFlashContent",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "虚拟利好量", prop: "flashUp" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formModal.flashUp,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "flashUp", $$v)
                          },
                          expression: "formModal.flashUp",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "虚拟利空量", prop: "flashDown" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入" },
                        model: {
                          value: _vm.formModal.flashDown,
                          callback: function ($$v) {
                            _vm.$set(_vm.formModal, "flashDown", $$v)
                          },
                          expression: "formModal.flashDown",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "语言", prop: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.formModal.language,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "language", $$v)
                            },
                            expression: "formModal.language",
                          },
                        },
                        _vm._l(Object.keys(_vm.languageType), function (item) {
                          return _c("el-option", {
                            key: item,
                            attrs: {
                              label: _vm.languageType[item],
                              value: item,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "状态", prop: "isShow" } },
                    [
                      _c(
                        "el-radio",
                        {
                          attrs: { label: true },
                          model: {
                            value: _vm.formModal.isShow,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "isShow", $$v)
                            },
                            expression: "formModal.isShow",
                          },
                        },
                        [_vm._v("开启")]
                      ),
                      _c(
                        "el-radio",
                        {
                          attrs: { label: false },
                          model: {
                            value: _vm.formModal.isShow,
                            callback: function ($$v) {
                              _vm.$set(_vm.formModal, "isShow", $$v)
                            },
                            expression: "formModal.isShow",
                          },
                        },
                        [_vm._v("关闭")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.setting.visible = false
                      _vm.$refs.formModal.resetFields()
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.settingEvent } },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }